export enum ConstituentsPref {
	CLIPS_ENABLED = 'asset.constituent.videoClips.enabled',
}
